import { onBeforeUnmount } from 'vue'

// Shared start/stop lifecycle for setInterval-based polling -- WirepasNetworkGrid and
// WirepasTopologyGraph both need the exact same "poll while active" pattern.
export function usePolling(fn: () => void, intervalMs: number) {
  let timer: ReturnType<typeof setInterval> | null = null
  const stop = () => { if (timer) { clearInterval(timer); timer = null } }
  const start = () => { stop(); timer = setInterval(fn, intervalMs) }
  onBeforeUnmount(stop)
  return { start, stop }
}
